import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Profile from "../../components/Profile/Profile";
import Loading from "../../components/Loading";
import { ClientProfile } from "../../interfaces/common";
import Api from "../../services/Api";
import { useSetAtom } from 'jotai';
import { toastAtom } from '../../jotai_state';
import {getLanguage} from "../../lang/helpers";
import {VectorFileInterface} from "./interfaces";


const ProfilePage: React.FC = () => {
  const api = Api.getInstance();
  const translation = useTranslation();
  const { t, i18n } = translation;
  const lang = getLanguage(i18n.language);
  const [loaded, setLoaded] = useState(false);
  const [customerFiles, setCustomerFiles] = useState<Array<VectorFileInterface>>([]);
  const [clientProfile, setClientProfile] = useState<ClientProfile>({
    id: 0,
    inCompanySince: 0,
    currentRoleSince: 0,
    title: "",
    roleDescription: "",
    aboutMe: "",
    leadershipLevel: "",
    languages: "",
    coachingExperience: -1,
    coachId: "0",
    languagesNative: [],
    languagesProfessional: [],
    coachingAreas: [],
    coachIndustryExperiences: [],
    picture: "",
  });
  const setGlobalToast = useSetAtom(toastAtom);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    api.get("client/account").then((response) => {
      if (response.json.profile) {
        setClientProfile(response.json.profile);
        setCustomerFiles(response.json.customerFiles);
      }
      setLoaded(true);
    });
  };

  const saveProfile = (profile: ClientProfile) => {
    api.post('client/account/update', profile).then(() => {
      setGlobalToast({text: lang === "sv" ? "Ändringar sparade" : "Changes saved"})
      getData();
    });
  };

  if (!loaded) {
    return <Loading />;
  }

  return (
    <div className="main-content">
      <Profile profile={clientProfile} save={saveProfile} standalone={true} customerFiles={customerFiles}/>
    </div>
  );
};

export default ProfilePage;
